<template>
  <q-dialog v-model="mobileAppUpdateDialog" persistent>
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar icon="update" color="primary" text-color="white" />
        <span class="q-ml-sm">
          Please update your app for new features and updates.
        </span>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          flat
          color="primary"
          label="Update"
          v-on:click="
            openURL(
              isAndroid
                ? 'https://play.google.com/store/apps/details?id=com.pitech.portfoliotracker'
                : isIos
                ? 'https://www.apple.com/app-store/'
                : 'https://chukul.com'
            )
          "
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { defineComponent, ref } from "vue";

import { App } from "@capacitor/app";

import useTools from "src/use/tools";

export default defineComponent({
  name: "MobileAppUpdate",

  setup() {
    const { getAndroidVersion } = useTools();

    const mobileAppUpdateDialog = ref(false);
    const isAndroid = ref(process.env.IS_ANDROID);
    const isIos = ref(process.env.IS_IOS);

    if (process.env.IS_CAPACITOR) {
      getAndroidVersion().then(async (res) => {
        const appInfo = await App.getInfo();
        if (appInfo.build < res.data.android_version)
          mobileAppUpdateDialog.value = true;
      });
    }

    function openURL(link) {
      window.open(link);
    }

    return {
      mobileAppUpdateDialog,
      isAndroid,
      isIos,
      openURL,
    };
  },
});
</script>
